const copy = {
    percent: ['Комиссия, %', 'Komissiya, %'],
    byPercent: ['Процент', 'Faizlə'],
    woltPreset: ['Wolt · 30%', 'Wolt · 30%'],
    percentHelp: ['От суммы погашения', 'Ödənilən borc məbləğindən'],
    rateInvalid: [
        'Введите процент 0–100, до двух знаков после запятой.',
        '0–100 faiz daxil edin, vergüldən sonra iki rəqəmədək.',
    ],
    type: ['Что за счёт?', 'Hansı hesab növüdür?'],
    money: ['Деньги', 'Pul'],
    moneyHelp: ['Касса, банк и другие денежные счета', 'Kassa, bank və digər pul hesabları'],
    receivable: ['Нам должны', 'Bizə borcludurlar'],
    receivableHelp: ['Ожидаемые поступления, например Walt', 'Gözlənilən daxilolmalar, məsələn Walt'],
    payable: ['Мы должны', 'Biz borcluyuq'],
    payableHelp: ['Расчёты с поставщиком', 'Təchizatçı ilə hesablaşma'],
    feeInvalid: [
        'Комиссия не оставляет реального поступления. Проверьте отчёт выплаты.',
        'Komissiyadan sonra real daxilolma qalmır. Ödəniş hesabatını yoxlayın.',
    ],
    exceeds: [
        'Сумма превышает подтверждённый долг сервиса. Уменьшите её или проверьте расчёты.',
        'Məbləğ servisin təsdiqlənmiş borcundan çoxdur. Məbləği azaldın və ya hesablaşmanı yoxlayın.',
    ],
    feeHelp: [
        'Укажите удержание по отчёту. Если комиссия ещё неизвестна, уточните её перед проведением; введённые данные останутся в форме.',
        'Hesabatdakı tutulmanı göstərin. Komissiya hələ məlum deyilsə, əməliyyatdan əvvəl dəqiqləşdirin; daxil etdiyiniz məlumatlar formada qalacaq.',
    ],
    reference: ['Номер отчёта выплаты', 'Ödəniş hesabatının nömrəsi'],
    accrued: ['Начислено', 'Hesablanıb'],
    accrue: ['Начислить за день', 'Gün üzrə hesabla'],
    settle: ['Получить выплату', 'Ödənişi qəbul et'],
    adjust: ['Уточнить сумму', 'Məbləği dəqiqləşdir'],
    opening: ['Нам должны на конец указанного дня', 'Göstərilən günün sonuna bizə olan borc'],
    openingConfirm: ['Этот начальный остаток проверен', 'Bu ilkin qalıq yoxlanılıb'],
    notMoney: [
        'Это ожидаемые деньги. В остаток кассы и банка они не входят.',
        'Bu gözlənilən puldur. Kassa və bank qalığına daxil deyil.',
    ],
    gross: ['Погасить долг на', 'Borcdan silinəcək'],
    feeChoice: ['Комиссия при выплате', 'Ödəniş komissiyası'],
    chooseFee: ['Укажите комиссию', 'Komissiyanı göstərin'],
    noFee: ['Комиссии нет', 'Komissiya yoxdur'],
    withFee: ['По отчёту: суммой', 'Hesabata görə: məbləğlə'],
    fee: ['Комиссия', 'Komissiya'],
    net: ['Поступит на счёт', 'Hesaba daxil olacaq'],
    funds: ['Куда поступят деньги', 'Pulun daxil olacağı hesab'],
    remaining: ['После выплаты нам должны', 'Ödənişdən sonra bizə borc'],
    accrueHelp: [
        'Укажите общую сумму за день до комиссии. Начисление увеличит ожидаемую сумму. Денег на банковском счёте пока не прибавится.',
        'Günün komissiyadan əvvəlki ümumi məbləğini göstərin. Hesablama gözlənilən məbləği artırır. Bank hesabına hələ pul daxil olmur.',
    ],
    settleHelp: [
        'На счёт поступит сумма после комиссии. Долг уменьшится на всю погашаемую сумму.',
        'Hesaba komissiyadan sonrakı məbləğ daxil olur. Borc tam ödənilən məbləğ qədər azalır.',
    ],
    saved: [
        'Сохранено. Деньги на счетах не изменились.',
        'Saxlanıldı. Pul hesablarının qalığı dəyişmədi.',
    ],
    settled: [
        'Выплата получена. Банк пополнен, ожидаемая сумма уменьшена.',
        'Ödəniş alındı. Bank hesabı artdı, gözlənilən məbləğ azaldı.',
    ],
    correction: ['Изменение: плюс или минус', 'Dəyişiklik: müsbət və ya mənfi'],
    history: ['Движения расчётов', 'Hesablaşma hərəkətləri'],
    openingKind: ['Начальный остаток', 'İlkin qalıq'],
    receipt: ['Получена выплата', 'Ödəniş alınıb'],
    correctionKind: ['Уточнение', 'Dəqiqləşdirmə'],
    empty: ['Таких счетов пока нет', 'Hələ belə hesab yoxdur'],
    newAccount: ['Создать счёт расчётов', 'Hesablaşma hesabı yarat'],
    existingParty: [
        'Выберите существующего контрагента или создайте нового. Это те же долги, повторный баланс не создаётся.',
        'Mövcud kontragent seçin və ya yenisini yaradın. Bunlar eyni borclardır; təkrar balans yaradılmır.',
    ],
    openParty: ['Открыть расчёты', 'Hesablaşmanı aç'],
};
const english = {
    percent: 'Fee, %',
    byPercent: 'Percentage',
    woltPreset: 'Wolt · 30%',
    percentHelp: 'Of the gross settled amount',
    rateInvalid: 'Enter 0–100 percent, with up to two decimal places.',
    type: 'Account type',
    money: 'Money',
    moneyHelp: 'Cash, bank and other money accounts',
    receivable: 'Owed to us',
    receivableHelp: 'Expected receipts, for example Wolt',
    payable: 'We owe',
    payableHelp: 'Supplier settlements',
    feeInvalid: 'The fee leaves no actual receipt. Check the payout report.',
    exceeds: 'The amount exceeds the confirmed debt. Reduce it or review the balance.',
    feeHelp: 'Use the fee from the payout report.',
    reference: 'Payout report reference',
    accrued: 'Accrued',
    accrue: 'Record daily sales',
    settle: 'Receive payout',
    adjust: 'Adjust amount',
    opening: 'Owed to us at the end of the date',
    openingConfirm: 'This opening balance has been verified',
    notMoney: 'Expected money is separate from cash and bank balances.',
    gross: 'Settle debt by',
    feeChoice: 'Payout fee',
    chooseFee: 'Choose the fee',
    noFee: 'No fee',
    withFee: 'Report: fee amount',
    fee: 'Fee',
    net: 'To the account',
    funds: 'Money destination',
    remaining: 'Owed to us after payout',
    accrueHelp: 'Enter daily gross sales before fees. This increases expected money, not the bank balance.',
    settleHelp: 'The account receives the net amount. Debt decreases by the gross settled amount.',
    saved: 'Saved. Money balances did not change.',
    settled: 'Payout received. Money increased and expected money decreased.',
    correction: 'Change: plus or minus',
    history: 'Settlement history',
    openingKind: 'Opening balance',
    receipt: 'Payout received',
    correctionKind: 'Adjustment',
    empty: 'No accounts yet',
    newAccount: 'Create settlement account',
    existingParty: 'Choose an existing counterparty or create one. This uses the same debts, without a second balance.',
    openParty: 'Open settlements',
};
export const cashReceivablesText = (locale, key) => locale === 'en' ? english[key] : copy[key][locale === 'az' ? 1 : 0];
export function cashReceivablesFailure(locale, code) {
    if (locale === 'en')
        return ({
            RECEIVABLE_HISTORICAL_EXCEEDS: 'Less was accrued by this date. Review the payout or adjustment date.',
            RECEIVABLE_VERSION_CONFLICT: 'The expected balance changed. Refresh and review the payout.',
            RECEIVABLE_OPENING_REQUIRED: 'Confirm the opening balance.',
            RECEIVABLE_ACCOUNT_EXISTS: 'This account already exists. Open the existing settlements.',
            RECEIVABLE_OPENING_OVERLAP: 'The date is already covered by the opening balance. Review it or enter a separate adjustment.',
            RECEIVABLE_DAY_EXISTS: 'This day is already recorded. Use an adjustment to change it.',
            RECEIVABLE_SETTLEMENT_MISMATCH: 'Gross settlement must equal the money received plus the fee.',
            RECEIVABLE_SETTLEMENT_EXCEEDS: 'The amount exceeds the remaining debt. Review the settlement.',
            RECEIVABLE_DUPLICATE_RECEIPT: 'A payout with this reference is already recorded. Do not repeat it.',
            RECEIVABLE_CURRENCY_MISMATCH: 'Choose a money account in the same currency.',
            RECEIVABLE_ADJUSTMENT_EXCEEDS: 'This adjustment would make the balance negative. Review previous payouts.',
        }[code || ''] || null);
    const errors = {
        RECEIVABLE_HISTORICAL_EXCEEDS: [
            'На эту дату начислено меньше. Проверьте дату выплаты или уточнения.',
            'Bu tarixə daha az məbləğ hesablanıb. Ödənişin və ya dəqiqləşdirmənin tarixini yoxlayın.',
        ],
        RECEIVABLE_VERSION_CONFLICT: [
            'Ожидаемая сумма изменилась. Обновите данные и проверьте выплату.',
            'Gözlənilən məbləğ dəyişib. Məlumatları yeniləyib ödənişi yoxlayın.',
        ],
        RECEIVABLE_OPENING_REQUIRED: ['Подтвердите начальный остаток.', 'İlkin qalığı təsdiqləyin.'],
        RECEIVABLE_ACCOUNT_EXISTS: [
            'Такой счёт уже есть. Откройте существующие расчёты.',
            'Belə hesab artıq var. Mövcud hesablaşmanı açın.',
        ],
        RECEIVABLE_OPENING_OVERLAP: [
            'Эта дата уже входит в начальный остаток. Проверьте дату или внесите отдельное уточнение.',
            'Bu tarix ilkin qalığa daxildir. Tarixi yoxlayın və ya ayrıca dəqiqləşdirmə edin.',
        ],
        RECEIVABLE_DAY_EXISTS: [
            'Этот день уже внесён. Для изменения используйте уточнение суммы.',
            'Bu gün artıq daxil edilib. Dəyişmək üçün məbləği dəqiqləşdirin.',
        ],
        RECEIVABLE_SETTLEMENT_MISMATCH: [
            'Погашение должно равняться поступлению в банк плюс комиссия.',
            'Borcdan silinən məbləğ banka daxil olan pul və komissiyanın cəminə bərabər olmalıdır.',
        ],
        RECEIVABLE_SETTLEMENT_EXCEEDS: [
            'Сумма больше оставшегося долга сервиса. Проверьте расчёты.',
            'Məbləğ servisin qalan borcundan çoxdur. Hesablaşmanı yoxlayın.',
        ],
        RECEIVABLE_DUPLICATE_RECEIPT: [
            'Выплата с этим номером уже зарегистрирована. Не повторяйте её.',
            'Bu nömrəli ödəniş artıq qeydə alınıb. Təkrar daxil etməyin.',
        ],
        RECEIVABLE_CURRENCY_MISMATCH: [
            'Выберите денежный счёт в той же валюте.',
            'Eyni valyutada pul hesabı seçin.',
        ],
        RECEIVABLE_ADJUSTMENT_EXCEEDS: [
            'Уточнение сделает остаток отрицательным. Сначала проверьте полученные выплаты.',
            'Dəqiqləşdirmə qalığı mənfi edər. Əvvəl alınmış ödənişləri yoxlayın.',
        ],
    };
    return errors[code || '']?.[locale === 'az' ? 1 : 0] || null;
}
